define.alias("ember-power-select/components/power-select", "preview-grid/components/power-select");